import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import Select from "react-select";
import { Button, Form } from "react-bootstrap";

import KanbanAPI from "../../../api/KanbanAPI";
import withRouter from "../../../util/WithRouter";
import Const from "../../../util/Constants";
import Util from "../../../util/Util";
import ApiUiController from "../../../controller/ApiUiController";
import FieldText from "../../common/FieldText";
import FieldSelect from "../../common/FieldSelect";
import FieldController from "../../../controller/FieldController";
import FieldMultiSelect from "../../common/FieldMultiSelect";

class KanbanUpdate extends React.Component {
  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);

    this.state = {
      inApiCall: id !== 0,
      inValid: {},
      kanban: {
        id,
        name: "",
        type: -1,
        model: 0,
        group_by: "",
      },
    };

    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.mainModel.view.fields.model.options = [
      {
        label: this.mainModel.lead.model_name,
        value: this.mainModel.lead.model_no,
        status: Const.Active
      },
    ];

    this.model = null;
    this.fields = [];

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf("/"));
  }

  componentDidMount() {
    if (this.state.kanban.id !== 0) {
      KanbanAPI.get(this.state.kanban.id, this.onReceived, this.onFail);
    } else {
      this.setState({ ...this.state, inApiCall: false });
    }
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = (kanban) => {
    const model = Object.keys(this.mainModel).find(
      (key) => this.mainModel[key].model_no === Const.Lead
    );
    this.model = this.mainModel[model];
    this.fields = FieldController.getFilterFields(this.model.fields);

    // Get group by field
    const groupByField = this.getGroupByField(kanban.group_by);

    this.setState({
      ...this.state,
      kanban: { 
        ...kanban, 
        group_by: groupByField 
      },
      inApiCall: false,
      inValid: {},
    });
  };

  getGroupByField = (groupByValue) => {
    if (!this.fields || !groupByValue) return null;
    
    const field = this.fields.find(f => f.fieldKey === groupByValue);
    if (field) {
      return {
        id: field.id,
        value: field.fieldKey,
        type: field.field_type,
        label: field.label_name,
      };
    }
    return null;
  };

  getGroupByOptions = () => {
    if (!this.fields) return [];
    
    const selectFields = this.fields.filter(
      field => field?.field_type?.startsWith(Const.Select)
    );

    return selectFields.map((field) => {
      const hiddenOptions = FieldController.getOptions(field);
      if(!field.fieldKey || !field.label_name || 
         field.fieldKey === "created_by" || 
         field.fieldKey === "updated_by" || 
         !(hiddenOptions ?? []).length) return null;
      
      return { 
        id: field.id,
        value: field.fieldKey, 
        type: field.field_type,
        label: field.label_name 
      };
    }).filter(Boolean);
  };

  onValueChange = (field, value) => {
    const kanban = { ...this.state.kanban };
    kanban[field] = value;
    if (field === "type" && value === 1) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 0;
    } else if (field === "type" && value === 2) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 0;
    } else if (field === "type" && value === 3) {
      this.mainModel.view.fields.roles.editable = 0;
      this.mainModel.view.fields.users.editable = 1;
    } else if (field === "type" && value === 0) {
      this.mainModel.view.fields.roles.editable = 1;
      this.mainModel.view.fields.users.editable = 1;
    }
    
    if (field === "model") {
      const model = Object.keys(this.mainModel).find(
        (key) => this.mainModel[key].model_no === value
      );
      if (model) {
        this.model = this.mainModel[model];
        this.fields = FieldController.getFilterFields(this.model.fields);
        // Reset group_by when model changes
        kanban.group_by = null;
      } else {
        this.model = null;
        this.fields = [];
        kanban.group_by = null;
      }
    }
    
    this.setState({ ...this.state, kanban: { ...kanban }, inValid: {} });
  };

  onGroupByChange = (selected) => {
    this.setState({
      ...this.state,
      kanban: { ...this.state.kanban, group_by: selected },
      inValid: { ...this.state.inValid, group_by: null }
    });
  };

  validateForm = () => {
    const errors = {};
    
    if (!this.state.kanban.name?.trim()) {
      errors.name = "Name is required";
    }
    
    if (!this.state.kanban.group_by?.value?.trim()) {
      errors.group_by = "Group By is required";
    }
    
    return errors;
  };

  onSave = () => {
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ ...this.state, inValid: errors });
      return;
    }
    this.setState({ ...this.state, inApiCall: true });
    const kanban = { ...this.state.kanban };
    kanban.group_by = kanban.group_by.value;
    KanbanAPI.save(kanban, this.onSaved, this.onFail);
  };

  onSaved = () => {
    Util.showNotification("Successful", "Kanban view saved successfully.", "success");
    KanbanAPI.list((res) => {
      reactLocalStorage.setObject(Const.KanbanViews, res);
    }, this.onFail);
    this.props.navigate(this.basePath);
  };

  render() {
    const groupByOptions = this.getGroupByOptions();

    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12">
              <h3>Kanban View</h3>
            </div>
          </div>

          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">

              {/* Name */}
              <FieldText
                key="name"
                id="name"
                field={this.mainModel.view.fields.name}
                value={this.state.kanban.name}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              {/* Type */}
              <FieldSelect
                key="type"
                id="type"
                field={this.mainModel.view.fields.type}
                value={this.state.kanban.type}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              {/* Model */}
              <FieldSelect
                key="model"
                id="model"
                field={this.mainModel.view.fields.model}
                value={this.state.kanban.model}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldMultiSelect
                key="roles"
                id="roles"
                field={this.mainModel.view.fields.roles}
                value={this.state.kanban.roles}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              <FieldMultiSelect
                key="users"
                id="users"
                field={this.mainModel.view.fields.users}
                value={this.state.kanban.users}
                onValueChange={this.onValueChange}
                inValid={this.state.inValid}
              />

              {/* Group By */}
              <div className="col-md-4">
                <label className="form-label">
                  Group By <span className="text-danger">*</span>
                </label>
                <Select
                  value={this.state.kanban.group_by}
                  onChange={this.onGroupByChange}
                  options={groupByOptions}
                  isMulti={false}
                  isSearchable={true}
                  className="assignselect"
                />
                {this.state.inValid.group_by && (
                  <div className="text-danger mt-1">
                    {this.state.inValid.group_by}
                  </div>
                )}
              </div>

              {/* Save Button */}
              <div className="col-md-12 text-center btnsend mt-5">
                <Button
                  variant="success"
                  onClick={this.onSave}
                  disabled={this.state.inApiCall}
                >
                  Save
                </Button>
              </div>

            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(KanbanUpdate);